import { DateDropdown, Field } from '../../../libs/gs-component-form';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Field as FormikField } from 'formik';
import React from 'react';

import { SharedFormProps } from '../../../helpers/useManageItem';
import Form from '../BusinessItem/Form';
import SubtleHeading from '../SubtleHeading';
import styles from './style.scss';

const RoomBlockDetails: React.FC<SharedFormProps> = props => (
  <Form {...props}>
    <SubtleHeading>Room Block Details</SubtleHeading>
    <FormRow>
      <FormColumn className={styles.checkInOverride} xs="12" md>
        <FormikField
          data-testid="check-in-date"
          name="checkInDate"
          label="Check-in Date"
          component={DateDropdown}
          readOnly={false}
        />
      </FormColumn>
      <FormColumn xs="12" md>
        <FormikField data-testid="block-code" name="guestCode" label="Block Code" component={Field} />
      </FormColumn>
    </FormRow>
    <FormRow>
      <FormColumn className={styles.override} xs="12" md>
        <FormikField
          data-testid="check-out-date"
          name="checkOutDate"
          label="Check-out Date"
          component={DateDropdown}
          readOnly={false}
        />
      </FormColumn>
      <FormColumn xs="12" md>
        <FormikField data-testid="room-rate" name="rate" label="Room Rate" component={Field} />
      </FormColumn>
    </FormRow>
  </Form>
);

export default RoomBlockDetails;
